import { axiosSwagger } from "@/axios";


export const state = {
    publicLocation: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
}


export const mutations = {
    loading: (state, loading) => {
        state.publicLocation.loading = loading;
    },
    setData: (state, data) => {
        state.publicLocation.data = data;
    },
    setTotal: (state, total) => {
        state.publicLocation.total = total;
    },
    add: (state, data) => {
        state.publicLocation.data.push(data);
    },
    remove: (state, id) => {
        state.publicLocation.data = state.publicLocation.data.filter((el) => el.id !== id);
    },
    update: (state, data) => {
        const index = state.publicLocation.data.findIndex(
            (item) => item.id === data.id
        );

        if (index !== -1) {
            state.publicLocation.data[index].publicLocation = data.publicLocation;
        }
    },
}


export const actions = {
    // eslint-disable-next-line no-unused-vars
    async printLocationQR({ commit }, data) {
        return await axiosSwagger
            .get(`/api/Report/Location/QR/${data.docType}/${data.locationId}`, { responseType: 'blob' })
            .then((response) => {
                return response;
            });
    },
    async getPublicLocationFiles({ commit }, id) {
        commit("loading", true);

        return await axiosSwagger
            .get(`/api/FileLocation/Public/Files/${id}`)
            .then((response) => {
                commit("loading", false);
                commit("setData", response.data);

                return response;
            })
            .catch(() => {
                commit("loading", false);
            });
    }
}
